  import React, { useEffect, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import "./ComplianceGptBot.scss";
  import TourDocGPT from "../../components/TourDocGPT/TourDocGPT";
  import { toggleTour } from "../../reducers/tourSlice";
  import Chat from "./Chat";
  import PromptLibrary from "../prompt-library/PromptLibrary";
  import { togglePrompt } from "../../reducers/promptSlice";
  import { useLocation } from "react-router-dom";
import {getTitleFromPath} from "../../libs/utilities/helpers/getTitle"
  const ComplianceGpt = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const tourState = useSelector((state) => state.tour);
    const [showHandAnimation, setShowHandAnimation] = useState(false);
    const showPrompt = useSelector((state) => state.prompt).show;
  
  
    useEffect(() => {
      if (showPrompt)
        setPrompt('');
    }, [showPrompt])
  
    useEffect(() => {
      let timeout;
      if (tourState.show) {
        timeout = setTimeout(() => {
          setShowHandAnimation(true);
        }, 1000)
      }
      return () => {
        clearTimeout(timeout)
      }
    }, [tourState])
  

  
  

  
    const [tourStep, setTourStep] = useState(0);
    const chatInput = document.getElementsByClassName('chat-input');
  
    const handleInputFocus = () => {
      dispatch(toggleTour({ show: false }))
      setShowHandAnimation(false);
      chatInput[0].style.zIndex = "inherit";
      const timeout = setTimeout(() => {
        setTourStep(0);
        clearTimeout(timeout);
      }, 500);
    }
  
    const handleChangeStep = (step) => {
      if (step === 1) {
        setTourStep(step);
        chatInput[0].style.zIndex = 9999;
      }
      if (step === 2) {
        handleInputFocus();
      }
    }
  
    const [prompt, setPrompt] = useState('');
  
    const getPrompt = (value) => {
      setPrompt(value.query)
      dispatch(togglePrompt({ show: false }))
    }
  
    return (
      <>
      <div className="heading-div">
        <p className="text5">
          {getTitleFromPath(location ?.pathname)}
        </p>
      </div>
        <TourDocGPT
          show={tourState.show}
          handleShow={handleInputFocus}
          page="enterprise-gpt"
          tourStep={tourStep}
          changeStep={handleChangeStep}
        />
  
          <Chat
            prompt={prompt}
            showTour={(tourState.show && showHandAnimation && tourStep === 1)}
            handleInputFocus={handleInputFocus}
          />
      </>
    );
  };
  
  export default ComplianceGpt;
  